import { ApolloClient } from 'apollo-client';
import fetch from 'node-fetch';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';

const link = new HttpLink({
  uri: process.env.REACT_APP_API_PLAYER_ENDPOINT,
  fetch,
});

const cache = new InMemoryCache();

const apolloClient = new ApolloClient({
  link,
  cache,
});

export default apolloClient;
